import { render, staticRenderFns } from "./HeadCenter.vue?vue&type=template&id=30a60f47&lang=pug"
import script from "./HeadCenter.vue?vue&type=script&lang=js"
export * from "./HeadCenter.vue?vue&type=script&lang=js"
import style0 from "./HeadCenter.vue?vue&type=style&index=0&id=30a60f47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports